import QRCode from "react-qr-code"

export default function QRCodeGenerator({ value, size = 150, className = "" }) {
  return (
    <div className={`inline-block p-2 bg-white rounded-lg border border-gray-300 ${className}`}>
      <QRCode
        size={size}
        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
        value={value}
        viewBox={`0 0 ${size} ${size}`}
      />
    </div>
  )
}
